<template>
  <div class="home-wrap">
    <tool-bar page-title=""/>
    <v-main class="background-gradient home-section">
      <div class="welcome-title">
        <h1>{{ $t('home.welcome') }}</h1>
        <h5>{{ $t('home.instruction') }}</h5>
      </div>
      <!-- Classe de ativo antes dos apps: e o filtro que qualifica tudo abaixo,
           entao vem primeiro na leitura. Lineares em sm+, empilhadas no celular. -->
      <v-row class="grid-modules">
        <v-col
          v-for="(c, id) in coreStore.assetClasses"
          :key="id"
          cols="12"
          sm="4"
          class="pa-1"
        >
          <base-asset-class
            :title="c"
            :id="id"
            :locked="coreStore.isInstrumentClassLocked(c)"
            @select="selectAssetClass"
          />
        </v-col>
      </v-row>

      <!-- cards: duas colunas. A ordem vem de coreStore.contentCard, que esta
           ordenado linha a linha (esquerda, direita) exatamente para este grid. -->
      <v-row class="grid-modules">
        <v-col
          v-for="c in coreStore.contentCard"
          :key="c.id"
          cols="12"
          sm="6"
          class="pa-1"
        >
          <base-badge
            :change-switch="checkSwitch"
            :icon="c.icon"
            :title="c.name"
            :value="isActive(c)"
            :is-disable="c.disabled"
            :is-locked="c.locked"
            :subtitle="$t(c.descKey)"
          />
        </v-col>
      </v-row>
      <first-login-modal v-model="firstLoginModal" />
    </v-main>
  </div>
</template>

<script>
import ContentCard from "@/components/common/ContentCard.vue";
import ToolBar from "../components/layout/ToolBar.vue";
import SettingsModal from "@/components/modal/SettingsModal.vue";
import { useCoreStore } from "@/store/coreStore";
import { useAuthStore } from "@/store/authStore";
import { mapStores } from "pinia";
import BaseBadge from "@/components/common/BaseBadge.vue";
import BaseAssetClass from "@/components/common/BaseAssetClass.vue";
import FirstLoginModal from "@/components/modal/FirstLoginModal.vue";
export default {
  components: {
    ContentCard,
    ToolBar,
    SettingsModal,
    BaseBadge,
    BaseAssetClass,
    FirstLoginModal,
  },
  async mounted() {
    let fav = this.coreStore.getSelectedProduct.name
    this.searchProduct=''
    if (fav === 'null' || fav === 'undefined'|| fav === '')
{
      fav= null;
    }
    const needsFirstLogin = await this.authStore.getAuth();
    this.firstLoginModal = needsFirstLogin;
  },
  data(){
    return {
      showDropdown: false,
      defaultSelect: null,
      searchProduct: '',
      filterList: [],
      firstLoginModal: false,
    };
  },
  watch:{
    selectedCard(card)
{
      if(card)
{
        this.coreStore.saveSelectedProduct({
          name:card.name,
          path:card.link,
          value: card.value
        })
      }
      }
      },
  computed:{
    ...mapStores(useCoreStore, useAuthStore),
    updateFav() {
      return this.coreStore.getSelectedProduct;
    },
    selectedCard() {
      const fav =
        typeof this.updateFav.name === "string" && this.updateFav.name.trim() !== ""
          ? this.updateFav.name.toLowerCase()
          : null;

      return this.coreStore.contentCard.find(card=> card.name.toLowerCase().includes(fav))
    },
    filteredProduct()
{
      const fav= this.coreStore.selectedProduct?.name?.toLowerCase();
      if(!fav) return this.coreStore.coreStore.contentCard;


      return this.coreStore.contentCard.filter((card) => {
        // if no favorite saved -> show all cards
        if (!fav) return true;
        return card.name.toLowerCase().includes(fav);
      });
    },
    filteredOptions() {
      const term = (this.searchProduct || '').toLowerCase()
      if (!term) return []
      if (this.coreStore.selectedProduct.name) return []

      const options =  this.coreStore.contentCard
        .map(c => c.name)
        .filter(n => n.toLowerCase().includes(term))

      if (options.length > 0 && !this.searchProduct) {
        this.searchProduct = options[0];
      }
      if(options.length>0 && !this.searchProduct)
{
        this.searchProduct = options[0]
      }
      return options;
    },
  },
  methods:{
    // Sem navegacao: classe sem acesso abre o request a demo aqui mesmo (o
    // modal e global, mora no App.vue e escuta o `requestDemo` da store).
    selectAssetClass(title) {
      if (!this.coreStore.isInstrumentClassLocked(title)) return
      this.coreStore.setRequestDemo(true)
    },
    isActive(c)
{
      return this.coreStore.selectedProduct?.name === c.name
    },
    checkSwitch(e){
      this.defaultSelect = e
      let selected = this.coreStore.contentCard.find(c=>c.name === e)
      if (!selected) return

      const saved = {
        name: selected.name,
        path: selected.link,
        value:selected.value
        }
      // App sem acesso navega (a view abre borrada, com o pedido de demo) mas
      // nao vira o padrao - o switch dele esta desabilitado, entao so o clique
      // no card chega aqui.
      if (!selected.locked) this.coreStore.saveSelectedProduct(saved)
      this.$router.push(saved.path)
      //window.location.reload()
    },
  },
};
</script>
<style scoped>
.welcome-title h5{
  /* O <h5> nao tinha estilo proprio e caia no default do browser: 0.83em e
     bold. E uma instrucao, nao um titulo - sobe para 1rem e perde o peso. */
  font-size: 1rem;
  font-weight: 400;
}
.grid-modules{
  width:100%;
  /* Fluida: 1100px onde couber, 92% do viewport onde nao couber. Substitui o
     `padding: 0 14rem` que existia no .background-gradient e nunca chegou a
     valer - o VMain do Vuetify escreve os quatro paddings inline, e inline
     ganha de folha de estilo. */
  max-width: min(880px, 92vw);
  /* `0 auto`, nunca `auto`. Como o .v-main__wrap e flex column, `margin: auto`
     nos eixos verticais faz o item ABSORVER o espaco livre do container - as
     duas fileiras eram empurradas para longe uma da outra. O centramento e
     trabalho do justify-content do wrap; aqui so o horizontal. */
  margin: 0 auto;
  /* O .row do Vuetify vem com `flex: 1 1 auto`. Em container flex COLUMN isso
     vira flex-grow vertical: cada fileira incha para engolir o espaco livre -
     muito numa tela grande, nada numa pequena, dai o espacamento parecer
     aleatorio. Pior: as colunas esticam junto e os cards, que sao fill-height,
     crescem com elas - era por isso que reduzir o padding dos cards nao mudava
     a altura deles. Aqui as fileiras tem que ter a altura do conteudo. */
  flex: 0 0 auto;
}

/* Alinhado a esquerda e na MESMA largura do grid, nao do viewport: assim a
   primeira letra do titulo cai exatamente sobre a borda esquerda do primeiro
   card, em vez de flutuar solta. */
.welcome-title{
  width: 100%;
  max-width: min(880px, 92vw);
  text-align: left;
  margin-bottom: var(--home-respiro);
}
.welcome-title h1{
  line-height: 1.15;
}
.grid-col{
  display:flex;
  flex-direction: column;
  gap: .5rem;
}
.background-gradient{
  /* min-height + auto, nao height + hidden: a fila de classes de ativo saiu da
     coluna lateral e virou uma linha acima dos cards, entao o bloco ficou mais
     alto que antes. Com overflow escondido num viewport curto o ultimo par de
     cards era simplesmente cortado, sem scroll para alcanca-lo. */
  min-height:100vh;
  overflow-y: auto;
  background-image: url('@/assets/BG_1.png');
  background-size: cover;
  scrollbar-width: none;
}
.transparent-card
{
  background-color: #9b730564;
  backdrop-filter: blur(10px);
  border: thin solid #febd0b;
  box-shadow:2px 2px 15px #8d6a08b2;
}

.transparent-card:hover
{
  background-color: #c7971364;
  transition: all .5s ease;
}

.transparent-card-disabled
{
  background-color: #9b730564;
  backdrop-filter: blur(10px);
  border: thin solid #febd0b;
  box-shadow:2px 2px 15px #8d6a08b2;
}

::v-deep .v-card{
  border:thin solid rgba(255, 255, 255, 0.2) !important;
}
::v-deep .v-input--switch .v-label {
  font-size: 20px !important;
  letter-spacing: .2rem;
  font-weight: 600 !important;
}
.container
{
  display: flex ;
  align-items: center ;
  flex-direction: column;
  justify-content: center;
  max-width: 1400px;
  margin:0 10rem;
}

.img-logo {
  width: 150px;
  max-width: 150px;
  margin-right: 2rem;
}

.first-col {
  border: 1px solid #ffbf009d;
  border-radius: 5px;
  background: #080808;
}

.first-col:hover {
  box-shadow: 0px 0px 10px 3px #ffbf0027;
  transition: 0.2s all ease-out;
}
.home-section{
  /* Respiro entre titulo e grid. Unico numero a mexer para deixar o bloco mais
     compacto ou mais arejado - as media queries de altura so o reescrevem. */
  --home-respiro: 1.5rem;
  display: flex;
  flex-direction: column;
  /* stretch, nao center: o wrap ocupa a largura toda e a centralizacao
     horizontal acontece dentro dele, junto com a vertical. */
  align-items: stretch;
}

/*
  A centralizacao mora AQUI e nao no .v-main. O VMain nao recebe os filhos
  direto: ele renderiza um div.v-main__wrap no meio, e o CSS do Vuetify da a
  esse wrap `flex: 1 1 auto`. Como unico item flex do .v-main, ele cresce e
  ocupa a altura inteira - entao um justify-content no pai nao tem folga
  nenhuma para distribuir e nao centra nada. Quem precisa centrar e o wrap.
  Precisa de ::v-deep porque o wrap e criado pelo render do VMain e nao carrega
  o atributo de escopo deste componente.

  Seguro contra conteudo alto: a altura vem de `min-height`, entao se o bloco
  passar de uma tela o container cresce e o justify-content vira no-op - sem o
  classico transbordo-para-cima inalcancavel do center em flex.
*/
::v-deep .v-main__wrap{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

a {
  display: block;
  text-decoration: none;
  height: 100%;
}
a:hover .v-icon {
  color: #ffbf00;
  transform: rotateZ(180deg);
  transition: all 0.4s ease;
}

@media screen and (max-width: 600px)
{
  .first-col{
    display: flex;
    flex-direction: column;
    align-items: center;
    height:auto;
    width:55%;
  }
}
/* Viewport baixo: a centralizacao so ajuda se o bloco couber. Encolher o
   respiro do titulo e o que mais rende, porque sao 52px de uma vez so. */
/* Viewport baixo: aperta o respiro antes de deixar o bloco estourar a tela. */
@media screen and (max-height: 800px) {
  .home-section { --home-respiro: 1rem; }
}
@media screen and (max-height: 680px) {
  .home-section { --home-respiro: 0.5rem; }
  .welcome-title h1 { font-size: 1.6rem; }
}
</style>
